import { PermissionCode } from '../../../shared/enums/permission-code';

export enum LeadTabs {
  DATA_AXLE = 'data-axle',
  VLF = 'vlf',
  WNCSBI = 'wncsbi',
  CUSTOM = 'custom',
  DEEPROOTS = 'deeproots',
}

export enum LeadSubTabs {
  ALL = 'all',
  MATCHED = 'matched',
  INQUIRIES = 'inquiries',
  ME = 'me',
  ORG = 'org',
  SUBMITTED = 'submitted',
  NOT_SUBMITTED = 'not-submitted',
  YES = 'true',
  NO = 'false',
  BY_LINK = 'link',
  SME = 'sme',
}

export enum LeadFilterTypes {
  MATCHED_CRITERIA = 'matched-criteria',
  PRE_LENDING_FORM = 'pre-lending-form',
  INQUIRY_SUBMISSIONS = 'inquiry_submissions',
}

export interface LeadsTabConfig {
  value: LeadTabs | LeadSubTabs;
  label: string;
  showCount?: boolean;
  permissionCode?: PermissionCode;
  showAdvancedFilters?: boolean;
  showAddBusinessButton?: boolean;
  filters?: LeadFilterTypes[];
  subTabs: LeadsTabConfig[];
  source?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload?: Record<string, any>;
}

export const PrelendingFormConfig: LeadsTabConfig[] = [
  {
    value: LeadSubTabs.ALL,
    label: 'All',
    subTabs: [],
  },
  {
    value: LeadSubTabs.YES,
    label: 'Yes',
    subTabs: [],
  },
  {
    value: LeadSubTabs.NO,
    label: 'No',
    subTabs: [],
  },
];

export const InquirySubmissions: LeadsTabConfig[] = [
  {
    value: LeadSubTabs.ALL,
    label: 'All Submissions',
    subTabs: [],
  },
  {
    value: LeadSubTabs.BY_LINK,
    label: 'By Link',
    subTabs: [],
  },
  {
    value: LeadSubTabs.SME,
    label: 'SME',
    subTabs: [],
  },
];

const deeprootsSubTabs: LeadsTabConfig[] = [
  {
    value: LeadSubTabs.MATCHED,
    label: 'Matched',
    showCount: true,
    filters: [LeadFilterTypes.MATCHED_CRITERIA],
    subTabs: [],
    payload: { matching_criteria: [] },
  },
  {
    value: LeadSubTabs.INQUIRIES,
    label: 'Inquiries',
    showCount: true,
    filters: [LeadFilterTypes.INQUIRY_SUBMISSIONS],
    subTabs: [],
    payload: { deeproots_inquiries: true },
  },
];

const referralsSubTabs: LeadsTabConfig[] = [
  {
    value: LeadSubTabs.ALL,
    label: 'All',
    subTabs: [],
  },
  {
    value: LeadSubTabs.ME,
    label: 'Created By Me',
    subTabs: [],
    payload: { self_created: true },
  },
  {
    value: LeadSubTabs.ORG,
    label: 'Created By Org',
    subTabs: [],
    payload: { self_org_created: true },
  },
  {
    value: LeadSubTabs.MATCHED,
    label: 'Matched',
    permissionCode: PermissionCode.ACCESS_DEEPROOTS,
    filters: [LeadFilterTypes.MATCHED_CRITERIA],
    subTabs: [],
    payload: { matching_criteria: [], referrals_only: true },
  },
];

const wncsbiSubTabs: LeadsTabConfig[] = [
  {
    value: LeadSubTabs.ALL,
    label: 'All',
    subTabs: [],
    filters: [LeadFilterTypes.PRE_LENDING_FORM],
  },
  {
    value: LeadSubTabs.SUBMITTED,
    label: 'Outreach Submitted',
    subTabs: [],
    payload: { outreach_status: true },
    filters: [LeadFilterTypes.PRE_LENDING_FORM],
  },
  {
    value: LeadSubTabs.NOT_SUBMITTED,
    label: 'Not Submitted',
    subTabs: [],
    payload: { outreach_status: false },
    filters: [LeadFilterTypes.PRE_LENDING_FORM],
  },
];

export const findLeadsConfig: LeadsTabConfig[] = [
  {
    value: LeadTabs.DEEPROOTS,
    label: 'DeepRoots',
    permissionCode: PermissionCode.ACCESS_DEEPROOTS,
    subTabs: deeprootsSubTabs,
    source: 'DEEP_ROOTS',
  },
  {
    value: LeadTabs.CUSTOM,
    label: 'Referrals',
    permissionCode: PermissionCode.CUSTOM_BUSINESS_RECORD,
    showAddBusinessButton: true,
    subTabs: referralsSubTabs,
    source: 'CUSTOM_BUSINESS_RECORDS',
  },
  {
    value: LeadTabs.WNCSBI,
    label: 'WNCSBI',
    permissionCode: PermissionCode.ACCESS_CRF,
    showAdvancedFilters: true,
    filters: [LeadFilterTypes.PRE_LENDING_FORM],
    subTabs: wncsbiSubTabs,
    source: 'WNCSBI_APPS',
  },
  {
    value: LeadTabs.DATA_AXLE,
    label: 'Data Axle',
    permissionCode: PermissionCode.ACCESS_DATA_AXLE,
    showAdvancedFilters: true,
    subTabs: [],
    source: 'DATA_AXLE',
  },
  {
    value: LeadTabs.VLF,
    label: 'VLF Leads',
    permissionCode: PermissionCode.ACCESS_VLF,
    showAdvancedFilters: false,
    subTabs: [],
    source: 'VLF',
  },
];
